export default {
  bills: {
    title: '月账单概览',
    balance: '当前余额：',
    rechargeNow: '立即充值',
    menu: '账单管理',
    statement: '账单流水',
    filter: {
      status: '状态',
      all: '全部',
    },
    table: {
      paymentDays: '账期',
      date: '出账日期',
      billAmount: '账单金额',
      paidAmount: '已支付金额',
      arrearsAmount: '欠款金额',
      billDetail: '月账单明细',
    },
    status: {
      settled: '已结清',
      unresolved: '未结清',
      unsettled: '未结算',
      settledTips: '已结清：已出帐，已支付的账单',
      unresolvedTips: '未结清：已出帐，未支付的账单',
      unsettledTips: '未结算：已消费，未出账的账单',
    },
  },
  billDetail: {
    table: {
      date: '日期',
      scene: '场景',
      materialTip: '素材消耗的单价受套餐控制，可能会变动',
      '3dmodelTip': '3D模型工单的单价也可能不一致，详细请查看3D模型工单列表',
      making: {
        '3dmodel': '3D模型制作',
        material: '素材消耗',
      },
      objectID: '业务ID',
      modelQuantity: '模型数量',
      impression: '广告展示',
      billImpression: '计费广告展示',
      cpm: '计费CPM',
    },
    options: {
      cap: '按渠道封顶',
      allCap: '全渠道封顶',
      buyout: '按渠道买断',
      allBuyout: '全渠道买断',
    },
  },
  statement: {
    search: {
      fingerprint: '请搜索素材指纹',
    },
    table: {
      advDisplayNum: '广告展示数',
      advClickNum: '广告点击数',
      advInstallNum: '广告安装数',
      advExpenses: '广告费用',
      chargingNum: '计费广告展示数',
      materialCosts: '素材费用',
      firstTips: '当素材费用到达封顶价后，',
      secondTips: '后续素材展示不再统计计费。',
    },
  },
  usage: {
    title: '用量明细',
    table: {
      date: '日期',
      usageType: '类型',
      value: '扣减数',
      unit: '单位',
    },
    bizType: {
      aiAsr: '语音识别',
      aiTts: '语音合成',
      aiDvs: '智能分镜',
      aigcCredits: 'AI视频',
      voiceClone: '语音克隆',
      videos: '视频导出',
      vrec: '录屏工具',
      download: '下载',
      push: '推送',
      aiBanner: '链接生图',
      videoOcr: '字幕识别',
      pptVideos: '链接生视频',
      avatarVideo: '数字人视频',
      replaceMaterial: 'AI消除',
      analysisOnly: '解析参考视频',
      analysisReplace: '解析参考视频',
      scriptRetain: '改写脚本',
      scriptReplace: '生成新脚本',
      newAssetNewScript: '新脚本生成资产',
      newAssetOldScript: '旧脚本+产品信息生资产',
      videoNewScript: '生成视频',
      videoOriginal: '生成视频',
    },
  },
  materials: {
    table: {
      date: '推送日期',
      project: '项目名称及ID',
      fingerprint: '素材指纹',
      trafficType: '推送渠道',
      totalImpression: '广告总展示',
      totalBillImpression: '计费广告展示',
      totalServiceFee: '费用',
      projectName: '项目名称',
      billMethod: '计费方式',
      billMethodNum: '数量',
      billNum: '计费数量',
      price: '单价',
      status: '计费状态',
      totalAmount: '素材总费用',
      createdTime: '开始计费日期',
      stopTime: '停止计费日期',
      serviceFee: '素材消耗费用',
      buyoutPrice: '买断价格',
      maxPrice: '价格上限',
      action: '操作',
      view: '预览',
      download: '下载',
      buyout: '买断',
      cap: '提前支付',
    },
    options: {
      charging: '计费中',
      endCharge: '计费结束',
    },
    capBuyoutDialog: {
      title: {
        cap: '提前支付创意费用',
        buyout: '买断创意',
      },
      tip: {
        cap: '是否需要提前支付以下创意费用？支付成功后，此素材不再统计素材消耗费用。若提前支付创意全部渠道费用，会自动开放此创意其它渠道下载权限。',
        buyout:
          '是否需要买断以下创意? 创意买断后，该创意从当日起不再统计素材消耗。若买断全部渠道，会自动开放此创意其它渠道下载权限。',
      },
      creativeId: '创意ID:',
      creativeName: '创意名称:',
      trafficType: '推送渠道:',
      price: '待支付金额:',
      balance: '账户当前余额:',
      disabledTip: '可用余额不足，无法购买。请充值后再次尝试。',
      successful: '支付成功',
      priceTip: {
        cap: '待支付金额是价格上限与已支付素材消耗费用的差额。',
        buyout:
          '同一个创意下，多个渠道分别买断的费用之和不会超过全渠道买断的费用。',
      },
    },
    downloadDialog: {
      editProductInfo: '修改产品信息',
      editProductInfoTip: '修改产品信息后需重新打包素材，过程需等待一段时间。',
    },
  },
  balanceThresholdTips: '余额不足，功能暂不可用。充值后可恢复使用Playturbo。',
  table: {
    bizType: '场景',
  },
  cost: {
    return: '点数返还',
    spend: '点数消费',
  },
  status: {
    fail: '失败',
  },
}
